import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import "./Home.css";
import logo from "../../assets/images/logo.jpg";
import { useEtatGlobal } from "../EtatGlobal.js";
import { useSectionActivityTracker } from "./useSectionActivityTracker.js";
import { normalizeText } from "../../utils/text.js";
import SignModif from "../SignModif/SignModif.js";
import Dashboard from "../Dashboard/dashboard.js";
import Bureau from "../Bureau/Bureau.jsx";
import Mails from "../Mails/Mails.jsx";
import Discussion from "../Discussion/Discussion.jsx";
import DiscussionNotifDrawer from "./DiscussionNotifDrawer.jsx";
import Planning from "../Planning/Planning.jsx";
import FeuilleTemps from "../FeuilleTemps/FeuilleTemps.js";
import Conges from "../Conges/Conges.js";
import ToDo from "../ToDo/ToDo.js";
import Lead from "../Lead/LMLead.js";
import Suivi from "../Suivis/Suivi.js";
import Portefeuille from "../Portefeuille/Portefeuille.js";
import Admin from "../Admin/Admin.js";
import IdentifiantsPA from "../Admin/IdentifiantsPA.js";
import SuperAdmin from "../SuperAdmin/SuperAdmin.js";
import Sign from "../SignModif/components/DetailsSign.js";
import Rdv from "../Rdv/Rdv.js";
import Mission from "../Mission/Mission.js";
import AddClient from "../Portefeuille/Create.js";
import Contrat from "../Contrat/Contrat.js";
import LeadMain from "../Lead/RDVLead.js";
import FormLead from "../Lead/FormLead.js";
import AllLead from "../Lead/AllLead.js";
import Evenement from "../Evenement/Evenement.js";
import AllEvenement from "../Evenement/AllEvenement.js";
import { useLocation } from "react-router-dom";
import TicketingForm from "../Ticketing/ticketingForm.js";
// import Ged from "../Ged/ged.js";
import MyalfaLink from "../MyalfaLink/myalfalink.js";
import Annuaire from "../Annuaire/Annuaire.js";
import RHelp from "../RHelp/rhelp.js";

// Icon
import TicketingAll from "../Ticketing/ticketingAll.js";
import Mandat from "../Mandat/Mandat.js";
import Recouvrement from "../Recouvrement/Recouvrement.js";
import Procedures from "../Procedures/Procedures.js";
import { estTesteur } from "../../utils/accesTesteurs.js";
import KnowledgeBase from "../KnowledgeBase/KnowledgeBase.js";
import GedClient from "../GedClient/GedClient.js";
import SI from "../SI/SI.js";
import LettresMission from "../LettresMission/LettresMission.js";
import {
  X,
  ChartLine,
  LayoutDashboard,
  Bell,
  Folder,
  Users,
  Table2,
  Wrench,
  Settings,
  List,
  LayoutGrid,
  Headphones,
  LogOut,
  Book,
  // FolderOpen, // entrée GED du menu commentée (voir plus bas)
  GraduationCap,
  FilePen,
  FileSignature,
  UserPlus,
  ClipboardPlus,
  Calendar,
  Briefcase,
  CalendarDays,
  ChevronRight,
  ChevronLeft,
  ChevronDown,
  CheckSquare,
  Building2,
  User,
  UserCog,
  ShieldCheck,
  Server,
  KeyRound,
  FileSpreadsheet,
  Bot,
  PanelLeftDashed,
} from "lucide-react";
import FloatingPanel from "./FloatingPanel.js";
import EvaChat from "../../components/EvaChat/EvaChat.js";

import { dialog } from "../../components/ui/Dialog";
const LeadIcon = ({ size = 24, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    <path d="M19.07 4.93l-1.41 1.41" />
    <path d="M15.17 15.17a4 4 0 0 0-5.66-5.66L4 14l6 6 5.17-4.83z" />
  </svg>
);


// Clé localStorage pour rester sur la même vue après un rafraîchissement
// (voir plan "Rester sur la même page après un rafraîchissement") — un
// simple objet plat, même style que les clés déjà en place (token, user,
// update_version).
const CURRENT_VIEW_STORAGE_KEY = "current_view";

// Reproduit exactement les règles de hasFeature/showAll définies plus bas
// dans le composant (utilisateur.fonctionalite), en fonction pure
// autonome pour pouvoir être appelée depuis les initialiseurs paresseux
// des useState (avant que ces closures internes n'existent). Ne PAS
// dupliquer les règles à la main ailleurs si elles changent un jour ici.
function hasFeatureFor(utilisateur, feature) {
  const list = utilisateur?.fonctionalite;
  if (!list || typeof list.includes !== "function") return false;
  return list.includes(feature) || list.includes("Admin");
}

// Une vue par clé : condition d'accès actuelle (copiée des gardes réelles
// de la sidebar). Volontairement ABSENTES de cette table : "Sign"/"LM"/
// "Contrat" (pilotées par des données transitoires — location.state /
// formData — jamais persistées, donc jamais sûres à restaurer après un
// rafraîchissement) et les vues orphelines sans point d'entrée réel
// ("Lead", "LeadMain", "MyAlfaLink", "RHelp") — canRestoreView renvoie
// alors simplement `false` pour elles, sans liste d'exclusion séparée.
// Recouvrement — fonctionnalité en cours de construction (pas encore de
// backend ni de flag "fonctionalite" dédié) : l'accès est limité aux quatre
// personnes qui la mettent au point. Comparaison toujours en minuscules.
// À remplacer par un flag/rôle (admin, experts-comptables, secrétariat) au
// moment du branchement backend. Liste dans utils/accesTesteurs.js (aussi
// utilisée par le partage d'une procédure).
const canAccessRecouvrement = estTesteur;

// Procédures (manuel du cabinet) — mêmes quatre testeurs que Recouvrement tant
// que la fonctionnalité est en construction (stockage local au navigateur, pas
// encore de backend). À élargir (rôle ou flag) au branchement de l'API.
const canAccessProcedures = canAccessRecouvrement;

// "Gestion interne" (Lettres de Mission / Mandats / Recouvrement) — réservé
// aux rôles Admin, Expert-comptable, Secrétariat (demande du 28/09/2026).
const GESTION_INTERNE_ROLES = ["ADMINISTRATEUR", "EXPERT_COMPTABLE", "SECRETARIAT"];
const canSeeGestionInterne = (u) => GESTION_INTERNE_ROLES.includes(u?.role);

const VIEW_ACCESS_GATES = {
  Mails: (u) => hasFeatureFor(u, "Admin"),
  Discussion: (u) => hasFeatureFor(u, "Admin"),
  Planning: (u) => hasFeatureFor(u, "Admin"),
  FeuilleTemps: (u) => hasFeatureFor(u, "Admin"),
  Conges: (u) => hasFeatureFor(u, "Admin"),
  Admin: (u) => hasFeatureFor(u, "Admin"),
  SuperAdmin: (u) => hasFeatureFor(u, "Admin"),
  AllEvent: (u) => hasFeatureFor(u, "Admin") || u?.role === "SECRETARIAT",
  // Identifiants PA seuls (sans le reste de la page Admin) : consultation par
  // tout collaborateur, décision d'Anthony du 26/10/2026.
  IdentifiantsPA: (u) => !!u,
  ticket: (u) => hasFeatureFor(u, "Admin"),
  // Système d'information (maquette si.jsx) : module Admin, comme l'API
  // (backend routes/siRoutes.js, requireAdminModule).
  SI: (u) => hasFeatureFor(u, "Admin"),
  Mandat: canSeeGestionInterne,
  Recouvrement: (u) => canSeeGestionInterne(u) && canAccessRecouvrement(u),
  Procedures: (u) => canAccessProcedures(u),
  // Base de connaissance : mêmes quatre testeurs que Procédures tant que
  // l'écran est en construction (stockage local au navigateur).
  KnowledgeBase: (u) => canAccessProcedures(u),
  // GED (page à part, maquette ged.jsx) : mêmes quatre testeurs.
  GedClient: (u) => canAccessProcedures(u),
  LettresMission: canSeeGestionInterne,
  AllLead: (u) => hasFeatureFor(u, "Lead"),
  Portefeuille: (u) => hasFeatureFor(u, "Portefeuille"),
  Suivi: (u) => hasFeatureFor(u, "Suivi Prod"),
};
// Bureau est maintenant ouvert à tous les collaborateurs (plus besoin du
// flag "Admin") — son contenu s'adapte déjà automatiquement au rôle
// (Bureau.jsx#profileForUser) ; rester ici reviendrait à réserver l'accès à
// ceux qui ont aussi Admin/SuperAdmin/Mails/Planning/..., ce qui n'est pas
// voulu (voir échange).
const VIEW_ALWAYS_RESTORABLE = new Set(["Dashboard", "ToDo", "Annuaire", "Bureau"]);

function canRestoreView(view, utilisateur) {
  if (VIEW_ALWAYS_RESTORABLE.has(view)) return true;
  const gate = VIEW_ACCESS_GATES[view];
  return gate ? gate(utilisateur) : false;
}

// Reflète currentView dans l'URL affichée (/home/<slug>) pour que le lien en
// haut du navigateur ne soit plus toujours "/home" — une entrée par vue
// restaurable (mêmes vues que VIEW_ACCESS_GATES/VIEW_ALWAYS_RESTORABLE).
// Volontairement absentes : les vues transitoires (Sign/LM/Contrat/...) qui
// ne sont de toute façon jamais restaurées — voir canRestoreView ci-dessus.
const VIEW_SLUGS = {
  Dashboard: "",
  Bureau: "bureau",
  ToDo: "todo",
  Annuaire: "annuaire",
  Mails: "mails",
  Discussion: "discussion",
  Planning: "planning",
  FeuilleTemps: "feuille-temps",
  Conges: "conges",
  Admin: "admin",
  SuperAdmin: "super-admin",
  AllEvent: "evenements",
  IdentifiantsPA: "identifiants-pa",
  ticket: "tickets",
  SI: "si",
  Mandat: "mandat",
  Recouvrement: "recouvrement",
  Procedures: "procedures",
  KnowledgeBase: "base-de-connaissance",
  GedClient: "ged",
  LettresMission: "lettres-mission",
  AllLead: "leads",
  Portefeuille: "portefeuille",
  Suivi: "suivi",
};
const SLUG_TO_VIEW = Object.fromEntries(
  Object.entries(VIEW_SLUGS)
    .filter(([, slug]) => slug)
    .map(([view, slug]) => [slug, view]),
);

// Renvoie la vue encodée dans l'URL, ou `null` si l'URL ne contient aucune
// indication exploitable (ex: "/home" nu après un login, ou un segment
// inconnu) — dans ce cas l'appelant se replie sur le localStorage.
function viewFromLocation(pathname) {
  const match = /^\/home\/?([^/?]+)/.exec(pathname || "");
  if (!match) return null;
  return SLUG_TO_VIEW[match[1]] || null;
}

function Home({ onLogout }) {
  const [showDiscussionDrawer, setShowDiscussionDrawer] = React.useState(false);
  const [initialConversationId, setInitialConversationId] = React.useState(null);
  const [showRdvPanel, setShowRdvPanel] = React.useState(false);
  const [showMissionOverlay, setShowMissionOverlay] = React.useState(false);
  const [showAddClientOverlay, setShowAddClientOverlay] = React.useState(false);
  const [showFromLeadOverlay, setShowFromLeadOverlay] = React.useState(false);
  const [showEventOverlay, setShowEventOverlay] = React.useState(false);
  const [showTicketOverlay, setShowTicketOverlay] = React.useState(false);
  const [showOverlayDetails, setShowOverlayDetails] = React.useState(false);
  const [showOverlayDetailsApps, setShowOverlayDetailsApps] =
    React.useState(false);
  const [showParamMenu, setShowParamMenu] = React.useState(false);
  const [showImpersonatePicker, setShowImpersonatePicker] =
    React.useState(false);
  const [impersonateSearch, setImpersonateSearch] = React.useState("");

  // 🔑 une ref par overlay
  const overlayDetailsRef = useRef(null);
  const overlayAppsRef = useRef(null);
  const missionOverlayRef = useRef(null);
  const paramMenuRef = useRef(null);
  const impersonatePickerRef = useRef(null);

  // Fermer si clic extérieur
  useEffect(() => {
    function handleClickOutside(event) {
      if (
        overlayDetailsRef.current &&
        !overlayDetailsRef.current.contains(event.target)
      ) {
        setShowOverlayDetails(false);
      }

      if (
        overlayAppsRef.current &&
        !overlayAppsRef.current.contains(event.target)
      ) {
        setShowOverlayDetailsApps(false);
      }

      if (
        paramMenuRef.current &&
        !paramMenuRef.current.contains(event.target)
      ) {
        setShowParamMenu(false);
      }

      if (
        impersonatePickerRef.current &&
        !impersonatePickerRef.current.contains(event.target)
      ) {
        setShowImpersonatePicker(false);
      }

      if (
        missionOverlayRef.current &&
        !missionOverlayRef.current.contains(event.target)
      ) {
        setShowMissionOverlay(false);
        setShowAddClientOverlay(false);
        setShowFromLeadOverlay(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const storedData = JSON.parse(sessionStorage.getItem("signingData"));
  const location = useLocation();
  const {
    pdfUrl,
    nom_client,
    email,
    comptable,
    selectedForm,
    display,
    leadId,
    clientId,
    civilite_lm,
    nom,
    prenom,
    telephone,
    siren,
    nombreLignesTableau,
    nombreLignesTexteLibre,
    formeSociale,
    societeNom,
    avenant,
  } = location.state || storedData || {};

  console.log(selectedForm);

  const navigate = useNavigate();
  const {
    utilisateur,
    setUtilisateur,
    afficheLM,
    setAfficheLM,
    fetchAll,
    showUpdateNotification,
    closeUpdateNotification,
    isLoading,
    users,
    impersonateUser,
    discussionUnreadCount,
  } = useEtatGlobal();

  // Restaure la vue quittée avant un rafraîchissement (voir plan "Rester
  // sur la même page après un rafraîchissement") — repli sur "Bureau"
  // (page d'accueil par défaut de la plateforme) si rien n'est stocké, si
  // la vue stockée n'existe plus, ou si l'utilisateur courant n'y a plus
  // accès (canRestoreView).
  const [savedView] = React.useState(() => {
    try {
      return JSON.parse(localStorage.getItem(CURRENT_VIEW_STORAGE_KEY)) || {};
    } catch {
      return {};
    }
  });
  // L'URL (ex: /home/conges?onglet=...) a priorité sur le localStorage si
  // elle contient une vue exploitable — ce qui couvre un lien partagé/tapé
  // à la main. Un "/home" nu (ex: juste après le login) ne donne aucune
  // indication : on se replie alors sur la dernière vue connue.
  const [currentView, setCurrentView] = React.useState(() => {
    const urlView = viewFromLocation(location.pathname);
    if (urlView && canRestoreView(urlView, utilisateur)) return urlView;
    return savedView.view && canRestoreView(savedView.view, utilisateur)
      ? savedView.view
      : "Bureau";
  });

  // Chronomètre le temps actif passé sur chaque écran et le remonte au
  // Super Admin (voir ConnexionsTab.js) — voir useSectionActivityTracker.js
  // pour le détail du fonctionnement (idle, flush, absence de reset explicite).
  useSectionActivityTracker(currentView);

  const [suiviInitialTab, setSuiviInitialTab] = React.useState(() => {
    if (currentView === "Suivi") {
      const onglet = new URLSearchParams(location.search).get("onglet");
      if (onglet) return onglet;
    }
    return savedView.suiviInitialTab || "Compta";
  });
  const [suiviNavKey, setSuiviNavKey] = React.useState(0);
  const [suiviMenuExpanded, setSuiviMenuExpanded] = React.useState(false);
  const [gestionInterneMenuExpanded, setGestionInterneMenuExpanded] =
    React.useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = React.useState(false);
  const [adminInitialView, setAdminInitialView] = React.useState(() => {
    if (currentView === "Admin") {
      const vue = new URLSearchParams(location.search).get("vue");
      if (vue) return vue;
    }
    return savedView.adminInitialView ?? null;
  });
  const [adminNavKey, setAdminNavKey] = React.useState(0);

  // Sauvegarde la vue courante (+ ses sous-onglets) à chaque changement, et
  // reflète la même chose dans l'URL affichée (remplace l'entrée d'historique
  // plutôt que d'en empiler une par changement de vue — ce ne sont pas de
  // vraies pages, voir CLAUDE.md "Navigation Model").
  React.useEffect(() => {
    try {
      localStorage.setItem(
        CURRENT_VIEW_STORAGE_KEY,
        JSON.stringify({
          view: currentView,
          suiviInitialTab,
          adminInitialView,
        }),
      );
    } catch {
      // ignore
    }

    const slug = VIEW_SLUGS[currentView];
    if (slug === undefined) return; // vue transitoire (Sign/LM/Contrat/...) : ne pas toucher l'URL

    const params = new URLSearchParams();
    if (currentView === "Suivi" && suiviInitialTab)
      params.set("onglet", suiviInitialTab);
    if (currentView === "Admin" && adminInitialView)
      params.set("vue", adminInitialView);
    // Fiche de procédure ouverte (?page=…) : tenue à jour par Procedures.js
    // lui-même, lue sur l'URL réelle (celle de `location` peut être en retard
    // d'un rendu quand Procedures vient de la modifier).
    if (currentView === "Procedures") {
      const fiche = new URLSearchParams(window.location.search).get("page");
      if (fiche) params.set("page", fiche);
    }
    const search = params.toString();
    const path = `/home${slug ? `/${slug}` : ""}${search ? `?${search}` : ""}`;

    if (location.pathname + location.search !== path) {
      // Préserve location.state : cet effet ne fait que corriger l'URL
      // visible pour qu'elle reflète currentView, il ne doit jamais avoir
      // pour effet de bord d'effacer un state transitoire (ex: display,
      // selectedForm, pdfUrl passés par SignModif/DocSing pour la vue
      // "Sign") — sinon un clic sur "Signer ce Document" alors que
      // currentView vaut encore l'ancienne vue restaurée (avant que l'effet
      // dédié à `display` ait pu basculer sur "Sign") perd silencieusement
      // ce state au moment même où cet effet corrige l'URL.
      navigate(path, { replace: true, state: location.state });
    }
    // location volontairement omis : il change à cause de ce même navigate,
    // l'inclure boucleraît sans rien y gagner (le garde ci-dessus suffit).
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentView, suiviInitialTab, adminInitialView, navigate]);

  const handleLogout = async () => {
    const confirmation = await dialog.confirm(
      "Voulez-vous vraiment vous déconnecter ?",
      { variant: "default" },
    );
    if (confirmation) {
      localStorage.removeItem("user");
      onLogout();
      setUtilisateur(null);
    }
  };

  useEffect(() => {
    if (afficheLM === true) {
      setCurrentView("LM");
      setAfficheLM(false);
    }
  }, [afficheLM, setAfficheLM]);

  // Sous-menu "Suivi Prod" : s'ouvre automatiquement quand on est sur cette
  // section (sidebar dépliée), se referme automatiquement si la sidebar est
  // réduite (comme aucun autre item n'a de sous-comportement en mode réduit).
  useEffect(() => {
    if (currentView === "Suivi" && !sidebarCollapsed) {
      setSuiviMenuExpanded(true);
    }
  }, [currentView, sidebarCollapsed]);

  useEffect(() => {
    if (sidebarCollapsed) {
      setSuiviMenuExpanded(false);
    }
  }, [sidebarCollapsed]);

  // Même principe que "Suivi Prod" ci-dessus pour le sous-menu "Gestion interne".
  useEffect(() => {
    if (
      ["Mandat", "Recouvrement", "Procedures", "LettresMission"].includes(
        currentView,
      ) &&
      !sidebarCollapsed
    ) {
      setGestionInterneMenuExpanded(true);
    }
  }, [currentView, sidebarCollapsed]);

  useEffect(() => {
    if (sidebarCollapsed) {
      setGestionInterneMenuExpanded(false);
    }
  }, [sidebarCollapsed]);

  const handleOpenIdentifiantsPA = () => {
    setAdminInitialView("identifiants-pa");
    setAdminNavKey((k) => k + 1);
    setCurrentView("Admin");
    setShowParamMenu(false);
  };

  const handleOpenImportMEG = () => {
    setAdminInitialView("import-meg");
    setAdminNavKey((k) => k + 1);
    setCurrentView("Admin");
    setShowParamMenu(false);
  };

  const handleOpenEvaInstructions = () => {
    setAdminInitialView("eva-instructions");
    setAdminNavKey((k) => k + 1);
    setCurrentView("Admin");
    setShowParamMenu(false);
  };

  const handleOpenCabinets = () => {
    setAdminInitialView("cabinets");
    setAdminNavKey((k) => k + 1);
    setCurrentView("Admin");
    setShowParamMenu(false);
  };

  const handleOpenKycLab = () => {
    setAdminInitialView("kyc-lab");
    setAdminNavKey((k) => k + 1);
    setCurrentView("Admin");
    setShowParamMenu(false);
  };

  const handleOpenCollaborateurs = () => {
    setAdminInitialView(null);
    setAdminNavKey((k) => k + 1);
    setCurrentView("Admin");
    setShowParamMenu(false);
  };

  const handleDashboardClick = () => {
    setCurrentView("Dashboard");
  };

  const handleBureauClick = () => {
    setCurrentView("Bureau");
  };

  const handleToDoClick = () => {
    setCurrentView("ToDo");
  };

  const handleAllLeadClick = () => {
    setCurrentView("AllLead");
  };

  const handleFormLeadfClick = () => {
    setShowFromLeadOverlay(true);
  };

  const handleLMClick = () => {
    setCurrentView("LM");
  };

  const handleSuiviPordClick = () => {
    if (sidebarCollapsed) {
      setCurrentView("Suivi");
      return;
    }
    setSuiviInitialTab("Compta");
    setSuiviNavKey((k) => k + 1);
    setCurrentView("Suivi");
    setSuiviMenuExpanded(true);
    // Un seul sous-menu ouvert à la fois — voir handleGestionInterneClick.
    setGestionInterneMenuExpanded(false);
  };

  const handleSuiviChevronToggle = (e) => {
    e.stopPropagation();
    setSuiviMenuExpanded((v) => {
      const next = !v;
      if (next) setGestionInterneMenuExpanded(false);
      return next;
    });
  };

  const handleSuiviTraitementsComptablesClick = () => {
    setSuiviInitialTab("TraitementsComptables");
    setSuiviNavKey((k) => k + 1);
    setCurrentView("Suivi");
  };

  const handleSuiviComptaFiscalClick = () => {
    setSuiviInitialTab("Compta");
    setSuiviNavKey((k) => k + 1);
    setCurrentView("Suivi");
  };

  const handleSuiviIRClick = () => {
    setSuiviInitialTab("IR");
    setSuiviNavKey((k) => k + 1);
    setCurrentView("Suivi");
  };

  const handleSuiviTNSClick = () => {
    setSuiviInitialTab("TNS");
    setSuiviNavKey((k) => k + 1);
    setCurrentView("Suivi");
  };

  const handleSuiviSocialClick = () => {
    setSuiviInitialTab("Social");
    setSuiviNavKey((k) => k + 1);
    setCurrentView("Suivi");
  };

  const handleSuiviJuridiqueClick = () => {
    setSuiviInitialTab("JuridiquePonctuelle");
    setSuiviNavKey((k) => k + 1);
    setCurrentView("Suivi");
  };

  const handleAllEventClick = () => {
    setCurrentView("AllEvent");
  };

  const handlePortefeuilleClick = () => {
    setCurrentView("Portefeuille");
  };

  const handleRdvClick = () => {
    setShowRdvPanel("Rdv");
  };

  const handleMissionClick = () => {
    setShowMissionOverlay(true);
  };

  const handleContratClick = () => {
    setCurrentView("Contrat");
  };

  const handleAddClientClick = () => {
    setShowAddClientOverlay(true);
  };

  const handleEvenementClick = () => {
    setShowEventOverlay(true);
  };

  const handleTicketClick = () => {
    setShowTicketOverlay(true);
  };

  const handleTicketListeClick = () => {
    setCurrentView("ticket");
  };

  const handleMandatClick = () => {
    setCurrentView("Mandat");
  };

  const handleRecouvrementClick = () => {
    setCurrentView("Recouvrement");
  };

  const handleLettresMissionClick = () => {
    setCurrentView("LettresMission");
  };

  const handleGestionInterneClick = () => {
    if (sidebarCollapsed) {
      setCurrentView("Mandat");
      return;
    }
    setGestionInterneMenuExpanded((v) => {
      const next = !v;
      // Un seul sous-menu ouvert à la fois — voir handleSuiviPordClick.
      if (next) setSuiviMenuExpanded(false);
      return next;
    });
  };

  const handleGestionInterneChevronToggle = (e) => {
    e.stopPropagation();
    setGestionInterneMenuExpanded((v) => {
      const next = !v;
      if (next) setSuiviMenuExpanded(false);
      return next;
    });
  };

  const handleSuperAdminClick = () => {
    setCurrentView("SuperAdmin");
  };

  const handleAnnuaireClick = () => {
    setCurrentView("Annuaire");
  };

  // const handleGedClick = () => {
  //   setCurrentView("Ged");
  // };

  const handleActionRapide = () => {
    setShowOverlayDetails(!showOverlayDetails);
  };

  const handleActionRapideApps = () => {
    setShowOverlayDetailsApps(!showOverlayDetailsApps);
  };

  console.log("c'est", display);

  const [dataSave, setDataSave] = React.useState(
    location.state?.dataSave || false,
  );
  console.log("data", dataSave);

  // Ce else forçait "Dashboard" à CHAQUE montage de Home (pas seulement au
  // rafraîchissement — aussi après l'aller-retour SignModif → /Visuel →
  // retour), ce qui écraserait la vue restaurée depuis localStorage dans
  // le même rendu. Ne doit s'appliquer qu'à une vraie sortie de l'écran
  // Sign (display passant de `false` à autre chose), jamais au montage.
  //
  // Un simple ref "premier montage" (mis à false après le premier appel)
  // NE SUFFIT PAS ici : ce composant est monté sous React.StrictMode
  // (voir index.js), qui ré-invoque délibérément chaque effet une seconde
  // fois en développement pour détecter les effets non idempotents — le
  // ref serait déjà passé à false avant ce deuxième appel du MÊME montage,
  // qui déclencherait alors le reset à tort. On compare donc la valeur
  // PRÉCÉDENTE de `display` à sa valeur actuelle (idempotent : les deux
  // invocations de StrictMode voient la même paire précédente/actuelle
  // tant que `display` n'a pas réellement changé).
  const previousDisplayRef = useRef(display);
  React.useEffect(() => {
    if (display === false) {
      setCurrentView("Sign");
    } else if (previousDisplayRef.current === false) {
      setCurrentView("Bureau");
    }
    previousDisplayRef.current = display;
  }, [display]);

  React.useEffect(() => {
    const isReload =
      performance.getEntriesByType("navigation")[0]?.type === "reload";

    if (isReload) {
      // Sign/LM dépendent de données transitoires (location.state/
      // formData) perdues au rafraîchissement — dans ces deux cas
      // seulement, on retombe sur Bureau plutôt que de restaurer un
      // écran cassé. Dans tous les autres cas, la vue restaurée depuis
      // localStorage (voir les useState plus haut) reste en place.
      if (display === false || dataSave === true) {
        setCurrentView("Bureau");
      }
      setDataSave(false);
      // Reste sur le chemin actuel (ex: /home/conges) : seul le state
      // transitoire (dataSave) doit être nettoyé, pas l'URL — sinon ça
      // écrase le slug de vue restauré juste au-dessus à chaque F5.
      navigate(location.pathname + location.search, {
        replace: true,
        state: { dataSave: false },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigate]);

  React.useEffect(() => {
    if (dataSave === true) {
      setCurrentView("LM");
    }
  }, [dataSave]);

  const showAll = utilisateur?.fonctionalite?.includes("Admin") || false;
  const hasFeature = (feature) =>
    utilisateur &&
    utilisateur.fonctionalite &&
    utilisateur.fonctionalite.includes
      ? utilisateur.fonctionalite.includes(feature) || showAll
      : showAll;

  const overlayRef = useRef(null);
  const inoverlayRef = useRef(null);

  // Fermer l'overlay si on clique en dehors de inoverlayRef
  useEffect(() => {
    function handleClickOutside(event) {
      if (
        overlayRef.current &&
        inoverlayRef.current &&
        overlayRef.current.contains(event.target) &&
        !inoverlayRef.current.contains(event.target)
      ) {
        setShowMissionOverlay(false);
        setShowAddClientOverlay(false);
        setShowFromLeadOverlay(false);
      }
    }

    if (showMissionOverlay) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showMissionOverlay, showAddClientOverlay, showFromLeadOverlay]);

  const navClass = (isActive) =>
    `flex items-center ${
      sidebarCollapsed ? "justify-center px-2" : "gap-3 px-3"
    } py-2 rounded-lg cursor-pointer text-[11px] transition-all mb-0.5 ${
      isActive ? "bg-white/20 font-semibold " : "hover:bg-white/10 font-normal"
    }`;

  return (
    <>
      <div
        className="flex h-screen overflow-hidden"
        style={{ "--sidebar-width": sidebarCollapsed ? "56px" : "208px" }}
      >
        {/* ===== SIDEBAR ===== */}
        <div
          className={`flex flex-col h-screen ${
            sidebarCollapsed ? "w-14 min-w-[56px]" : "w-52 min-w-[208px]"
          } bg-[#5C1A30] text-white rounded-r-3xl transition-all duration-300 overflow-hidden`}
        >
          {/* Logo */}
          <div
            className={`flex items-center gap-3 ${
              sidebarCollapsed ? "justify-center px-3" : "px-4"
            } py-4`}
          >
            <img
              src={logo}
              alt="Logo"
              className="w-8 h-8 object-contain cursor-pointer rounded-lg flex-shrink-0"
              onClick={fetchAll}
            />
            {!sidebarCollapsed && (
              <span className="font-semibold text-[11px] tracking-wide truncate">
                MyALFA Worksync
              </span>
            )}
          </div>
          <div className="h-px bg-white/10 mx-3 mb-1" />

          {/* Toggle collapse button */}
          <div
            className={`flex ${
              sidebarCollapsed ? "justify-center" : "justify-end"
            } px-2 mb-1`}
          >
            <button
              onClick={() => setSidebarCollapsed(!sidebarCollapsed)}
              className="w-6 h-6 flex items-center justify-center rounded-md bg-white/15 text-white/60 hover:bg-white/25 hover:text-white transition-all duration-200"
            >
              {sidebarCollapsed ? (
                <ChevronRight size={12} />
              ) : (
                <ChevronLeft size={12} />
              )}
            </button>
          </div>

          {/* Navigation */}
          <nav className="flex-1 px-2 overflow-y-auto">
            {/* Ouvert à tous les collaborateurs — plus besoin du flag "Admin",
                voir VIEW_ALWAYS_RESTORABLE plus haut. */}
            <div
              className={navClass(currentView === "Bureau")}
              onClick={handleBureauClick}
            >
              <LayoutDashboard size={18} className="flex-shrink-0" />
              {!sidebarCollapsed && (
                <span className="text-[11px]">Bureau</span>
              )}
            </div>
            {hasFeature("Admin") && (
              <div
                className={navClass(currentView === "Dashboard")}
                onClick={handleDashboardClick}
              >
                <ChartLine size={18} className="flex-shrink-0" />
                {!sidebarCollapsed && (
                  <span className="text-[11px]">Tableau de bord</span>
                )}
              </div>
            )}

            <div
              className={navClass(currentView === "ToDo")}
              onClick={handleToDoClick}
            >
              <CheckSquare size={18} className="flex-shrink-0" />
              {!sidebarCollapsed && <span className="text-[11px]">ToDo</span>}
            </div>
            {hasFeature("Lead") && (
              <div
                className={navClass(currentView === "AllLead")}
                onClick={handleAllLeadClick}
              >
                <LeadIcon size={18} className="flex-shrink-0" />
                {!sidebarCollapsed && <span className="text-[11px]">Lead</span>}
              </div>
            )}
            {hasFeature("Portefeuille") && (
              <div
                className={navClass(currentView === "Portefeuille")}
                onClick={handlePortefeuilleClick}
              >
                <Folder size={18} className="flex-shrink-0" />
                {!sidebarCollapsed && (
                  <span className="text-[11px]">Portefeuille</span>
                )}
              </div>
            )}
            {/* GED : entrée du menu commentée, la GED est désormais dans
                l'onglet GED de la fiche client (comme la maquette).
            {canAccessProcedures(utilisateur) && (
              <div
                className={navClass(currentView === "GedClient")}
                onClick={() => setCurrentView("GedClient")}
              >
                <FolderOpen size={18} className="flex-shrink-0" />
                {!sidebarCollapsed && <span className="text-[11px]">GED</span>}
              </div>
            )}
            */}
            <div
              className={navClass(currentView === "Annuaire")}
              onClick={handleAnnuaireClick}
            >
              <Users size={18} className="flex-shrink-0" />
              {!sidebarCollapsed && (
                <span className="text-[11px]">Annuaire</span>
              )}
            </div>
            {hasFeature("Suivi Prod") && (
              <>
                <div
                  className={navClass(currentView === "Suivi")}
                  onClick={handleSuiviPordClick}
                >
                  <Table2 size={18} className="flex-shrink-0" />
                  {!sidebarCollapsed && (
                    <>
                      <span className="text-[11px] flex-1">Suivi Prod</span>
                      <button
                        onClick={handleSuiviChevronToggle}
                        className="flex-shrink-0 p-0.5 rounded hover:bg-white/10"
                      >
                        {suiviMenuExpanded ? (
                          <ChevronDown size={13} />
                        ) : (
                          <ChevronRight size={13} />
                        )}
                      </button>
                    </>
                  )}
                </div>
                {!sidebarCollapsed && suiviMenuExpanded && (
                  <div className="ml-2 pl-3 border-l border-white/10 mb-0.5">
                    {[
                      {
                        label: "Traitements comptables",
                        onClick: handleSuiviTraitementsComptablesClick,
                        isActive: suiviInitialTab === "TraitementsComptables",
                      },
                      {
                        label: "Compta / fiscal",
                        onClick: handleSuiviComptaFiscalClick,
                        isActive: [
                          "Compta",
                          "Bilan",
                          "IS",
                          "TVAMensuel",
                          "TVARSI",
                          "CFE",
                        ].includes(suiviInitialTab),
                      },
                      {
                        label: "IR",
                        onClick: handleSuiviIRClick,
                        isActive: suiviInitialTab === "IR",
                      },
                      {
                        label: "TNS",
                        onClick: handleSuiviTNSClick,
                        isActive: suiviInitialTab === "TNS",
                      },
                      {
                        label: "Social",
                        onClick: handleSuiviSocialClick,
                        isActive: suiviInitialTab === "Social",
                      },
                      {
                        label: "Juridique",
                        onClick: handleSuiviJuridiqueClick,
                        isActive: ["JuridiquePonctuelle", "JuridiqueAGO"].includes(
                          suiviInitialTab,
                        ),
                      },
                    ].map((item) => (
                      <div
                        key={item.label}
                        className={`flex items-center gap-2 py-1.5 px-2 rounded-lg cursor-pointer text-[11px] transition-all mb-0.5 ${
                          currentView === "Suivi" && item.isActive
                            ? "bg-white/20 font-semibold"
                            : "hover:bg-white/10 font-normal"
                        }`}
                        onClick={item.onClick}
                      >
                        {item.label}
                      </div>
                    ))}
                  </div>
                )}
              </>
            )}

            {/* Regroupe Lettres de Mission (à venir) / Mandats / Recouvrement
                — réservé aux rôles Admin / Expert-comptable / Secrétariat
                (demande du 28/09/2026). Recouvrement garde en plus sa
                restriction WIP (canAccessRecouvrement) au sein de ces rôles. */}
            {canSeeGestionInterne(utilisateur) && (
              <>
                <div
                  className={navClass(
                    [
                      "Mandat",
                      "Recouvrement",
                      "Procedures",
                      "LettresMission",
                    ].includes(currentView),
                  )}
                  onClick={handleGestionInterneClick}
                >
                  <PanelLeftDashed size={18} className="flex-shrink-0" />
                  {!sidebarCollapsed && (
                    <>
                      <span className="text-[11px] flex-1">Gestion interne</span>
                      <button
                        onClick={handleGestionInterneChevronToggle}
                        className="flex-shrink-0 p-0.5 rounded hover:bg-white/10"
                      >
                        {gestionInterneMenuExpanded ? (
                          <ChevronDown size={13} />
                        ) : (
                          <ChevronRight size={13} />
                        )}
                      </button>
                    </>
                  )}
                </div>
                {!sidebarCollapsed && gestionInterneMenuExpanded && (
                  <div className="ml-2 pl-3 border-l border-white/10 mb-0.5">
                    {[
                      {
                        label: "Lettres de Mission",
                        onClick: handleLettresMissionClick,
                        isActive: currentView === "LettresMission",
                        visible: true,
                      },
                      {
                        label: "Mandats",
                        onClick: handleMandatClick,
                        isActive: currentView === "Mandat",
                        visible: true,
                      },
                      {
                        label: "Recouvrement",
                        onClick: handleRecouvrementClick,
                        isActive: currentView === "Recouvrement",
                        visible: canAccessRecouvrement(utilisateur),
                      },
                    ]
                      .filter((item) => item.visible)
                      .map((item) => (
                        <div
                          key={item.label}
                          className={`flex items-center gap-2 py-1.5 px-2 rounded-lg cursor-pointer text-[11px] transition-all mb-0.5 ${
                            item.isActive
                              ? "bg-white/20 font-semibold"
                              : "hover:bg-white/10 font-normal"
                          }`}
                          onClick={item.onClick}
                        >
                          {item.label}
                        </div>
                      ))}
                  </div>
                )}
              </>
            )}

            {hasFeature("Admin") && (
              <>
                {!sidebarCollapsed ? (
                  <div className="pt-5 pb-1 px-3">
                    <p className="text-[10px] font-semibold uppercase tracking-widest text-white/50">
                      Administrateur
                    </p>
                  </div>
                ) : (
                  <div className="pt-4 pb-1 mx-2 border-t border-white/10" />
                )}
                <div
                  className={navClass(currentView === "ticket")}
                  onClick={handleTicketListeClick}
                >
                  <Wrench size={18} className="flex-shrink-0" />
                  {!sidebarCollapsed && (
                    <span className="text-[11px]">Tickets</span>
                  )}
                </div>
                <div
                  className={navClass(currentView === "SI")}
                  onClick={() => setCurrentView("SI")}
                  title="Système d'information"
                >
                  <Server size={18} className="flex-shrink-0" />
                  {!sidebarCollapsed && (
                    <span className="text-[11px]">S.I</span>
                  )}
                </div>
                <div
                  className={navClass(currentView === "SuperAdmin")}
                  onClick={handleSuperAdminClick}
                >
                  <ShieldCheck size={18} className="flex-shrink-0" />
                  {!sidebarCollapsed && (
                    <span className="text-[11px]">Statistique</span>
                  )}
                </div>
              </>
            )}
            {/* Événements : ouvert aussi au secrétariat, pas seulement à
                l'Admin — voir VIEW_ACCESS_GATES.AllEvent. Mandats/Recouvrement
                sont maintenant dans le sous-menu "Gestion interne" ci-dessous. */}
            {(hasFeature("Admin") || utilisateur?.role === "SECRETARIAT") && (
              <div
                className={navClass(currentView === "AllEvent")}
                onClick={handleAllEventClick}
              >
                <Calendar size={18} className="flex-shrink-0" />
                {!sidebarCollapsed && (
                  <span className="text-[11px]">Événements</span>
                )}
              </div>
            )}

            {/* Identifiants PA par défaut du cabinet : consultation par tout
                collaborateur (vue seule), modification par les
                administrateurs dans la page Admin — décision d'Anthony du
                26/10/2026. */}
            {utilisateur && (
              <div
                className={navClass(
                  currentView === "IdentifiantsPA" ||
                    (currentView === "Admin" && adminInitialView === "identifiants-pa"),
                )}
                onClick={
                  utilisateur?.allCabinetsAccess || utilisateur?.role === "ADMINISTRATEUR"
                    ? handleOpenIdentifiantsPA
                    : () => setCurrentView("IdentifiantsPA")
                }
              >
                <KeyRound size={18} className="flex-shrink-0" />
                {!sidebarCollapsed && (
                  <span className="text-[11px]">Identifiants PA</span>
                )}
              </div>
            )}

            {/* Réservé aux administrateurs — outil de conversion Excel MEG. */}
            {(utilisateur?.allCabinetsAccess ||
              utilisateur?.role === "ADMINISTRATEUR") && (
              <div
                className={navClass(currentView === "Admin" && adminInitialView === "import-meg")}
                onClick={handleOpenImportMEG}
              >
                <FileSpreadsheet size={18} className="flex-shrink-0" />
                {!sidebarCollapsed && (
                  <span className="text-[11px]">MEG</span>
                )}
              </div>
            )}

            {/* Réservé aux administrateurs — instructions personnalisées
                pour Eva (l'assistante IA), injectées dans son system prompt. */}
            {(utilisateur?.allCabinetsAccess ||
              utilisateur?.role === "ADMINISTRATEUR") && (
              <div
                className={navClass(currentView === "Admin" && adminInitialView === "eva-instructions")}
                onClick={handleOpenEvaInstructions}
              >
                <Bot size={18} className="flex-shrink-0" />
                {!sidebarCollapsed && (
                  <span className="text-[11px]">Instructions Eva</span>
                )}
              </div>
            )}

          </nav>

          {/* User profile */}
          <div className="h-px bg-white/10 mx-3" />
          <div
            className={`flex items-center ${
              sidebarCollapsed ? "justify-center px-2" : "gap-3 px-4"
            } py-4`}
          >
            <div className="w-9 h-9 rounded-full bg-white/20 flex items-center justify-center text-sm font-bold uppercase flex-shrink-0">
              {utilisateur?.name?.[0]}
              {utilisateur?.lastName?.[0]}
            </div>
            {!sidebarCollapsed && (
              <>
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-semibold truncate">
                    {utilisateur?.name?.charAt(0)}. {utilisateur?.lastName}
                  </p>
                  <p className="text-xs text-white/60 truncate">
                    {utilisateur?.poste ||
                      utilisateur?.profession ||
                      "Collaborateur"}
                  </p>
                </div>
                {hasFeature("Admin") && (
                  <button
                    onClick={() => setShowParamMenu(!showParamMenu)}
                    className={`flex items-center justify-center w-8 h-8 rounded-full transition-colors flex-shrink-0 ${
                      showParamMenu
                        ? "bg-white text-[#5C1A30]"
                        : "text-white/60 hover:text-white"
                    }`}
                  >
                    <Settings size={18} />
                  </button>
                )}
              </>
            )}
          </div>

          {showParamMenu && (
            <div
              ref={paramMenuRef}
              className="fixed left-4 bottom-[96px] z-50 w-80 bg-white rounded-2xl shadow-2xl border border-gray-100 overflow-hidden"
            >
              <div className="px-5 pt-4 pb-3 border-b border-gray-100">
                <p className="text-[10px] font-bold uppercase tracking-widest text-[#5C1A30]">
                  Paramétrage
                </p>
              </div>
              <div className="py-1.5">
                <div
                  onClick={handleOpenCabinets}
                  className="flex items-center gap-3 px-4 py-2.5 cursor-pointer group hover:bg-[#5C1A30]/5 transition-colors"
                >
                  <div className="w-8 h-8 rounded-lg bg-[#f5ede8] flex items-center justify-center flex-shrink-0">
                    <Building2 size={15} className="text-[#5C1A30]" />
                  </div>
                  <span className="text-sm text-gray-700 group-hover:text-[#5C1A30] flex-1 transition-colors">
                    Liste des cabinets
                  </span>
                  <ChevronRight
                    size={13}
                    className="text-gray-300 group-hover:text-[#5C1A30] transition-colors"
                  />
                </div>
                <div
                  onClick={handleOpenCollaborateurs}
                  className="flex items-center gap-3 px-4 py-2.5 cursor-pointer group hover:bg-[#5C1A30]/5 transition-colors"
                >
                  <div className="w-8 h-8 rounded-lg bg-[#f5ede8] flex items-center justify-center flex-shrink-0">
                    <User size={15} className="text-[#5C1A30]" />
                  </div>
                  <span className="text-sm text-gray-700 group-hover:text-[#5C1A30] flex-1 transition-colors">
                    Liste des collaborateurs
                  </span>
                  <ChevronRight
                    size={13}
                    className="text-gray-300 group-hover:text-[#5C1A30] transition-colors"
                  />
                </div>
                <div
                  onClick={handleOpenKycLab}
                  className="flex items-center gap-3 px-4 py-2.5 cursor-pointer group hover:bg-[#5C1A30]/5 transition-colors"
                >
                  <div className="w-8 h-8 rounded-lg bg-[#f5ede8] flex items-center justify-center flex-shrink-0">
                    <ShieldCheck size={15} className="text-[#5C1A30]" />
                  </div>
                  <span className="text-sm text-gray-700 group-hover:text-[#5C1A30] flex-1 transition-colors">
                    Paramètres KYC/LAB
                  </span>
                  <ChevronRight
                    size={13}
                    className="text-gray-300 group-hover:text-[#5C1A30] transition-colors"
                  />
                </div>
              </div>
            </div>
          )}
        </div>

        {/* ===== MAIN CONTENT ===== */}
        <div className="flex-1 flex flex-col overflow-hidden">
          {/* Top action bar */}
          <div className="flex items-center justify-between px-6 py-3 bg-white border-b">
            <div>
              <p className="text-[11px] text-gray-400 uppercase tracking-widest font-medium">
                {new Date()
                  .toLocaleDateString("fr-FR", {
                    weekday: "long",
                    day: "numeric",
                    month: "long",
                    year: "numeric",
                  })
                  .toUpperCase()}
              </p>
              <p className="text-sm text-gray-700 mt-0.5">
                Bonjour{" "}
                <span className="font-semibold text-gray-900">
                  {utilisateur?.lastName} {utilisateur?.name}
                </span>
              </p>
            </div>
            <div className="flex items-center bg-gray-100 rounded-lg px-1 py-1 gap-0.5">
              <button
                onClick={() => setShowDiscussionDrawer(true)}
                className="relative w-8 h-8 flex items-center justify-center rounded-md text-gray-900 hover:bg-[#5C1A30]/10 hover:text-[#5C1A30] transition-colors"
              >
                <Bell size={14} />
                {discussionUnreadCount > 0 && (
                  <span
                    className="absolute flex items-center justify-center text-white font-bold"
                    style={{
                      top: -4,
                      right: -4,
                      minWidth: 16,
                      height: 16,
                      padding: "0 4px",
                      background: "#840040",
                      fontSize: 9,
                      borderRadius: 999,
                      border: "1.5px solid #fff",
                      lineHeight: 1,
                    }}
                  >
                    {discussionUnreadCount > 99 ? "99+" : discussionUnreadCount}
                  </span>
                )}
              </button>
              <button
                className="w-8 h-8 flex items-center justify-center rounded-md text-gray-900 hover:bg-[#5C1A30]/10 hover:text-[#5C1A30] transition-colors"
                onClick={handleActionRapide}
              >
                <List size={14} />
              </button>
              <button
                className={`w-8 h-8 flex items-center justify-center rounded-md hover:bg-[#5C1A30]/10 hover:text-[#5C1A30] transition-colors ${showOverlayDetailsApps ? "bg-[#5C1A30]/10 text-[#5C1A30]" : "text-gray-900"}`}
                onClick={handleActionRapideApps}
              >
                <LayoutGrid size={14} />
              </button>
              <button
                className="w-8 h-8 flex items-center justify-center rounded-md text-gray-900 hover:bg-[#5C1A30]/10 hover:text-[#5C1A30] transition-colors"
                onClick={handleTicketClick}
              >
                <Headphones size={14} />
              </button>
              <button
                className="w-8 h-8 flex items-center justify-center rounded-md text-gray-900 hover:bg-red-50 hover:text-red-500 transition-colors"
                onClick={handleLogout}
              >
                <LogOut size={14} />
              </button>
            </div>
          </div>
          {showDiscussionDrawer && (
            <DiscussionNotifDrawer
              onClose={() => setShowDiscussionDrawer(false)}
              onOpenConversation={(conversationId) => {
                setInitialConversationId(conversationId);
                setShowDiscussionDrawer(false);
                setCurrentView("Discussion");
              }}
            />
          )}
          {isLoading && (
            <div className="w-full bg-[#840040] text-xs py-2 text-white pl-5">
              Chargement des données...
            </div>
          )}

          <div className="flex-1 overflow-auto p-4  bg-[#faf7f4]">
            {currentView === "Dashboard" && (
              <Dashboard
                onNav={(view) => {
                  const map = {
                    portef: "Portefeuille",
                    lead: "AllLead",
                    suivi: "Suivi",
                    suivi_juridique: "Suivi",
                    todo: "ToDo",
                  };
                  if (map[view]) {
                    setSuiviInitialTab(
                      view === "suivi_juridique"
                        ? "JuridiquePonctuelle"
                        : "Compta",
                    );
                    setSuiviNavKey((k) => k + 1);
                    setCurrentView(map[view]);
                  }
                }}
              />
            )}
            {currentView === "Bureau" && (
              <Bureau
                onNav={(view) => {
                  if (view === "traitements") {
                    setSuiviInitialTab("TraitementsComptables");
                    setSuiviNavKey((k) => k + 1);
                    setCurrentView("Suivi");
                    return;
                  }
                  if (view === "suivi_juridique") {
                    setSuiviInitialTab("JuridiquePonctuelle");
                    setSuiviNavKey((k) => k + 1);
                    setCurrentView("Suivi");
                    return;
                  }
                  if (view === "suivi_compta") {
                    setSuiviInitialTab("Compta");
                    setSuiviNavKey((k) => k + 1);
                    setCurrentView("Suivi");
                    return;
                  }
                  if (view === "suivi_social") {
                    setSuiviInitialTab("Social");
                    setSuiviNavKey((k) => k + 1);
                    setCurrentView("Suivi");
                    return;
                  }
                  const map = {
                    portef: "Portefeuille",
                    annuaire: "Annuaire",
                    todo: "ToDo",
                    mails: "Mails",
                    discussion: "Discussion",
                    agenda: "Planning",
                    temps: "FeuilleTemps",
                    conges: "Conges",
                    lead: "AllLead",
                  };
                  if (map[view]) setCurrentView(map[view]);
                }}
              />
            )}
            {currentView === "Mails" && (
              <Mails onBack={() => setCurrentView("Bureau")} />
            )}
            {currentView === "Discussion" && (
              <Discussion
                onBack={() => setCurrentView("Bureau")}
                initialConversationId={initialConversationId}
                onInitialConversationConsumed={() => setInitialConversationId(null)}
              />
            )}
            {currentView === "Planning" && (
              <Planning onBack={() => setCurrentView("Bureau")} />
            )}
            {currentView === "FeuilleTemps" && (
              <FeuilleTemps onBack={() => setCurrentView("Bureau")} />
            )}
            {currentView === "Conges" && (
              <Conges onBack={() => setCurrentView("Bureau")} />
            )}
            {currentView === "ToDo" && <ToDo />}
            {currentView === "Lead" && <Lead />}
            {currentView === "LM" && <SignModif />}
            {currentView === "Portefeuille" && <Portefeuille />}
            {currentView === "Suivi" && (
              <Suivi initialTab={suiviInitialTab} navKey={suiviNavKey} />
            )}
            {currentView === "Admin" && (
              <Admin initialView={adminInitialView} navKey={adminNavKey} />
            )}
            {currentView === "IdentifiantsPA" && (
              <IdentifiantsPA onCancel={() => setCurrentView("Dashboard")} />
            )}
            {currentView === "SuperAdmin" && <SuperAdmin />}
            {currentView === "Sign" && selectedForm && (
              <Sign
                pdfUrl={pdfUrl}
                nom_client={nom_client}
                email={email}
                comptable={comptable}
                selectedForm={selectedForm}
                civilite_lm={civilite_lm}
                nom={nom}
                prenom={prenom}
                telephone={telephone}
                siren={siren}
                leadId={leadId}
                clientId={clientId}
                nombreLignesTableau={nombreLignesTableau}
                nombreLignesTexteLibre={nombreLignesTexteLibre}
                formeSociale={formeSociale}
                societeNom={societeNom}
                avenant={avenant}
              />
            )}
            {currentView === "Contrat" && <Contrat />}
            {currentView === "LeadMain" && <LeadMain />}
            {currentView === "AllLead" && <AllLead />}
            {currentView === "AllEvent" && <AllEvenement />}
            {currentView === "ticket" && <TicketingAll />}
            {currentView === "Mandat" && <Mandat />}
            {currentView === "Recouvrement" && <Recouvrement />}
            {currentView === "Procedures" && <Procedures />}
            {currentView === "KnowledgeBase" && <KnowledgeBase />}
            {currentView === "GedClient" && <GedClient />}
            {currentView === "SI" && <SI />}
            {currentView === "LettresMission" && (
              <LettresMission onCreateLM={handleLMClick} />
            )}
            {currentView === "MyAlfaLink" && <MyalfaLink />}
            {currentView === "Annuaire" && <Annuaire />}
            {currentView === "RHelp" && <RHelp />}
            {/* {currentView === "Ged" && <Ged />} */}
          </div>

          {/* EVA, l'assistante IA : disponible sur tous les écrans */}
          <EvaChat currentView={currentView} />

          {showRdvPanel && (
            <FloatingPanel
              title="Rendez-vous"
              onClose={() => setShowRdvPanel(false)}
            >
              <Rdv />
            </FloatingPanel>
          )}

          {showOverlayDetailsApps && (
            <div
              ref={overlayAppsRef}
              className="absolute right-5 top-[60px] z-50 w-[300px] bg-white rounded-2xl shadow-2xl border border-gray-100 overflow-hidden"
            >
              <div className="px-5 pt-4 pb-2">
                <p className="text-[10px] font-bold uppercase tracking-widest text-[#6E1A36]">
                  Modules
                </p>
              </div>
              <div className="p-2 pt-1">
                {[
                  canAccessProcedures(utilisateur) && {
                    key: "procedures",
                    icon: <Book size={18} />,
                    titre: "Procédures",
                    detail: "Manuel de procédures du cabinet",
                    action: () => setCurrentView("Procedures"),
                  },
                  {
                    key: "kb",
                    icon: <Folder size={18} />,
                    titre: "Base de connaissance",
                    detail: "Documentation métier et recherches",
                    // Testeurs : nouvel écran intégré ; les autres gardent le wiki.
                    action: () =>
                      canAccessProcedures(utilisateur)
                        ? setCurrentView("KnowledgeBase")
                        : window.open("https://wiki.alfa-partenaires.com/", "_blank"),
                  },
                  !canAccessProcedures(utilisateur) && {
                    key: "elearning",
                    icon: <GraduationCap size={18} />,
                    titre: "E-learning",
                    detail: "Formations du cabinet",
                    action: () =>
                      window.open(
                        "https://formation.alfa-partenaires.com/",
                        "_blank",
                      ),
                  },
                ]
                  .filter(Boolean)
                  .map((m) => (
                    <button
                      key={m.key}
                      type="button"
                      onClick={() => {
                        setShowOverlayDetailsApps(false);
                        m.action();
                      }}
                      className="flex items-center gap-3 w-full text-left p-2.5 rounded-[9px] hover:bg-[#fff6ee] transition-colors"
                    >
                      <span className="w-[38px] h-[38px] rounded-[10px] bg-[#f3edef] text-[#6E1A36] flex items-center justify-center flex-shrink-0">
                        {m.icon}
                      </span>
                      <span className="flex flex-col min-w-0">
                        <b className="text-[13.5px] font-bold text-[#1f1620]">
                          {m.titre}
                        </b>
                        <small className="text-[12px] text-[#8a7780]">
                          {m.detail}
                        </small>
                      </span>
                    </button>
                  ))}
              </div>
            </div>
          )}

          {showOverlayDetails && (
            <div
              ref={overlayDetailsRef}
              className="absolute right-5 top-[60px] z-50 w-72 bg-white rounded-2xl shadow-2xl border border-gray-100 overflow-hidden"
            >
              <div className="px-5 pt-4 pb-3 border-b border-gray-100">
                <p className="text-[10px] font-bold uppercase tracking-widest text-[#5C1A30]">
                  Actions rapides
                </p>
              </div>
              <div className="py-1.5">
                {utilisateur?.allCabinetsAccess && (
                  <div
                    onClick={() => {
                      setShowOverlayDetails(false);
                      setImpersonateSearch("");
                      setShowImpersonatePicker(true);
                    }}
                    className="flex items-center gap-3 px-4 py-2.5 cursor-pointer group hover:bg-[#5C1A30]/5 transition-colors"
                  >
                    <div className="w-8 h-8 rounded-lg bg-[#f5ede8] flex items-center justify-center flex-shrink-0">
                      <UserCog size={15} className="text-[#5C1A30]" />
                    </div>
                    <span className="text-sm text-gray-700 group-hover:text-[#5C1A30] flex-1 transition-colors">
                      Se connecter en tant que
                    </span>
                    <ChevronRight
                      size={13}
                      className="text-gray-300 group-hover:text-[#5C1A30] transition-colors"
                    />
                  </div>
                )}
                {hasFeature("Créer une lettre de mission") && (
                  <div
                    onClick={handleLMClick}
                    className="flex items-center gap-3 px-4 py-2.5 cursor-pointer group hover:bg-[#5C1A30]/5 transition-colors"
                  >
                    <div className="w-8 h-8 rounded-lg bg-[#f5ede8] flex items-center justify-center flex-shrink-0">
                      <FilePen size={15} className="text-[#5C1A30]" />
                    </div>
                    <span className="text-sm text-gray-700 group-hover:text-[#5C1A30] flex-1 transition-colors">
                      Créer une lettre de mission
                    </span>
                    <ChevronRight
                      size={13}
                      className="text-gray-300 group-hover:text-[#5C1A30] transition-colors"
                    />
                  </div>
                )}
                {hasFeature("Créer un contrat de travail") && (
                  <div
                    onClick={handleContratClick}
                    className="flex items-center gap-3 px-4 py-2.5 cursor-pointer group hover:bg-[#5C1A30]/5 transition-colors"
                  >
                    <div className="w-8 h-8 rounded-lg bg-[#f5ede8] flex items-center justify-center flex-shrink-0">
                      <FileSignature size={15} className="text-[#5C1A30]" />
                    </div>
                    <span className="text-sm text-gray-700 group-hover:text-[#5C1A30] flex-1 transition-colors">
                      Créer un contrat de travail
                    </span>
                    <ChevronRight
                      size={13}
                      className="text-gray-300 group-hover:text-[#5C1A30] transition-colors"
                    />
                  </div>
                )}
                {hasFeature("Ajouter un client") && (
                  <div
                    onClick={handleAddClientClick}
                    className="flex items-center gap-3 px-4 py-2.5 cursor-pointer group hover:bg-[#5C1A30]/5 transition-colors"
                  >
                    <div className="w-8 h-8 rounded-lg bg-[#f5ede8] flex items-center justify-center flex-shrink-0">
                      <UserPlus size={15} className="text-[#5C1A30]" />
                    </div>
                    <span className="text-sm text-gray-700 group-hover:text-[#5C1A30] flex-1 transition-colors">
                      Ajouter un client
                    </span>
                    <ChevronRight
                      size={13}
                      className="text-gray-300 group-hover:text-[#5C1A30] transition-colors"
                    />
                  </div>
                )}
                {hasFeature("Créer une mission ponctuelle") && (
                  <div
                    onClick={handleFormLeadfClick}
                    className="flex items-center gap-3 px-4 py-2.5 cursor-pointer group hover:bg-[#5C1A30]/5 transition-colors"
                  >
                    <div className="w-8 h-8 rounded-lg bg-[#f5ede8] flex items-center justify-center flex-shrink-0">
                      <ClipboardPlus size={15} className="text-[#5C1A30]" />
                    </div>
                    <span className="text-sm text-gray-700 group-hover:text-[#5C1A30] flex-1 transition-colors">
                      Ajouter un LEAD
                    </span>
                    <ChevronRight
                      size={13}
                      className="text-gray-300 group-hover:text-[#5C1A30] transition-colors"
                    />
                  </div>
                )}
                {hasFeature("Créer une note de RDV") && (
                  <div
                    onClick={handleRdvClick}
                    className="flex items-center gap-3 px-4 py-2.5 cursor-pointer group hover:bg-[#5C1A30]/5 transition-colors"
                  >
                    <div className="w-8 h-8 rounded-lg bg-[#f5ede8] flex items-center justify-center flex-shrink-0">
                      <Calendar size={15} className="text-[#5C1A30]" />
                    </div>
                    <span className="text-sm text-gray-700 group-hover:text-[#5C1A30] flex-1 transition-colors">
                      Créer une note de RDV
                    </span>
                    <ChevronRight
                      size={13}
                      className="text-gray-300 group-hover:text-[#5C1A30] transition-colors"
                    />
                  </div>
                )}
                {hasFeature("Créer une mission ponctuelle") && (
                  <div
                    onClick={handleMissionClick}
                    className="flex items-center gap-3 px-4 py-2.5 cursor-pointer group hover:bg-[#5C1A30]/5 transition-colors"
                  >
                    <div className="w-8 h-8 rounded-lg bg-[#f5ede8] flex items-center justify-center flex-shrink-0">
                      <Briefcase size={15} className="text-[#5C1A30]" />
                    </div>
                    <span className="text-sm text-gray-700 group-hover:text-[#5C1A30] flex-1 transition-colors">
                      Mission ponctuelle
                    </span>
                    <ChevronRight
                      size={13}
                      className="text-gray-300 group-hover:text-[#5C1A30] transition-colors"
                    />
                  </div>
                )}
                <div
                  onClick={handleEvenementClick}
                  className="flex items-center gap-3 px-4 py-2.5 cursor-pointer group hover:bg-[#5C1A30]/5 transition-colors"
                >
                  <div className="w-8 h-8 rounded-lg bg-[#f5ede8] flex items-center justify-center flex-shrink-0">
                    <CalendarDays size={15} className="text-[#5C1A30]" />
                  </div>
                  <span className="text-sm text-gray-700 group-hover:text-[#5C1A30] flex-1 transition-colors">
                    Créer un évènement
                  </span>
                  <ChevronRight
                    size={13}
                    className="text-gray-300 group-hover:text-[#5C1A30] transition-colors"
                  />
                </div>
              </div>
            </div>
          )}

          {showImpersonatePicker && (
            <div
              ref={impersonatePickerRef}
              className="absolute right-5 top-[60px] z-50 w-72 bg-white rounded-2xl shadow-2xl border border-gray-100 overflow-hidden"
            >
              <div className="px-5 pt-4 pb-3 border-b border-gray-100">
                <p className="text-[10px] font-bold uppercase tracking-widest text-[#5C1A30] mb-2">
                  Se connecter en tant que
                </p>
                <input
                  autoFocus
                  type="text"
                  value={impersonateSearch}
                  onChange={(e) => setImpersonateSearch(e.target.value)}
                  placeholder="Rechercher un collaborateur…"
                  className="w-full h-8 rounded-lg border border-gray-200 px-2.5 text-xs outline-none focus:border-[#840040] transition-colors"
                />
              </div>
              <div className="py-1.5 max-h-72 overflow-y-auto">
                {users
                  .filter((u) => u.id !== utilisateur.id)
                  .filter((u) =>
                    normalizeText(`${u.name} ${u.lastName}`).includes(
                      normalizeText(impersonateSearch),
                    ),
                  )
                  .map((u) => (
                    <div
                      key={u.id}
                      onClick={async () => {
                        const confirmed = await dialog.confirm(
                          `Se connecter en tant que ${u.name} ${u.lastName} ?`,
                        );
                        if (confirmed) {
                          await impersonateUser(u.id);
                          setShowImpersonatePicker(false);
                        }
                      }}
                      className="flex items-center gap-3 px-4 py-2 cursor-pointer hover:bg-[#5C1A30]/5 transition-colors"
                    >
                      <span className="w-7 h-7 rounded-full bg-[#5C1A30] text-white text-[10px] font-bold flex items-center justify-center flex-shrink-0 uppercase">
                        {u.name?.[0]}
                        {u.lastName?.[0]}
                      </span>
                      <span className="text-sm text-gray-700 truncate">
                        {u.name} {u.lastName}
                      </span>
                    </div>
                  ))}
              </div>
            </div>
          )}
        </div>
      </div>
      {showMissionOverlay && (
        <div className="overlayAC" ref={overlayRef}>
          <div className="inoverlayMS" ref={inoverlayRef}>
            <button
              className="close-button"
              onClick={() => setShowMissionOverlay(false)}
              style={{
                position: "absolute",
                top: "12px",
                right: "12px",
                background: "transparent",
                border: "none",
                cursor: "pointer",
                zIndex: 10000,
              }}
            >
              <button
                aria-label="Fermer"
                className="p-2 rounded-md text-gray-500 hover:text-gray-800 bg-gray-200 transition"
              >
                <X className="w-4 h-4" />
              </button>
            </button>
            <Mission onCancel={() => setShowMissionOverlay(false)} />
          </div>
        </div>
      )}
      {showAddClientOverlay && (
        <div className="overlayAC" ref={overlayRef}>
          <div className="inoverlayLead" ref={inoverlayRef}>
            <button
              className="close-button"
              onClick={() => setShowAddClientOverlay(false)}
              style={{
                position: "absolute",
                top: "12px",
                right: "12px",
                background: "transparent",
                border: "none",
                cursor: "pointer",
                zIndex: 10000,
              }}
            >
              <button
                aria-label="Fermer"
                className="p-2 rounded-md text-gray-500 hover:text-gray-800 bg-gray-200 transition"
              >
                <X className="w-4 h-4" />
              </button>
            </button>
            <AddClient onCancel={() => setShowAddClientOverlay(false)} />
          </div>
        </div>
      )}
      {showFromLeadOverlay && (
        <div className="overlayAC" ref={overlayRef}>
          <div className="inoverlayMS" ref={inoverlayRef}>
            <button
              className="close-button"
              onClick={() => setShowFromLeadOverlay(false)}
              style={{
                position: "absolute",
                top: "12px",
                right: "12px",
                background: "transparent",
                border: "none",
                cursor: "pointer",
                zIndex: 10000,
              }}
            >
              <button
                aria-label="Fermer"
                className="p-2 rounded-md text-gray-500 hover:text-gray-800 bg-gray-200 transition"
              >
                <X className="w-4 h-4" />
              </button>
            </button>
            <FormLead onCancel={() => setShowFromLeadOverlay(false)} />
          </div>
        </div>
      )}
      {showEventOverlay && (
        <div className="overlayAC" ref={overlayRef}>
          <div
            className="inoverlayMS"
            ref={inoverlayRef}
            style={{ maxWidth: 720, height: "90vh" }}
          >
            <Evenement onCancel={() => setShowEventOverlay(false)} />
          </div>
        </div>
      )}
      {showTicketOverlay && (
        <div className="overlayAC" ref={overlayRef}>
          <div className="inoverlayMS" ref={inoverlayRef}>
            <button
              className="close-button"
              onClick={() => setShowTicketOverlay(false)}
              style={{
                position: "absolute",
                top: "12px",
                right: "12px",
                background: "transparent",
                border: "none",
                cursor: "pointer",
                zIndex: 10000,
              }}
            >
              <button
                aria-label="Fermer"
                className="p-2 rounded-md text-gray-500 hover:text-gray-800 bg-gray-200 transition"
              >
                <X className="w-4 h-4" />
              </button>
            </button>
            <TicketingForm onCancel={() => setShowTicketOverlay(false)} />
          </div>
        </div>
      )}
      {showUpdateNotification && (
        <div className="overlayNotification" ref={overlayRef}>
          <div className="inoverlayNotification" ref={inoverlayRef}>
            <div
              style={{
                maxWidth: "600px",
                margin: "auto",
                padding: "50px 50px",
                fontFamily: "Arial, sans-serif",
                border: "1px solid #ddd",
                borderRadius: "8px",
                boxShadow: "2px 2px 10px rgba(0,0,0,0.1)",
                textAlign: "left",
                backgroundColor: "#fff",
              }}
            >
              <div
                style={{
                  borderBottom: "3px solid #840040",
                  paddingBottom: "10px",
                  marginBottom: "20px",
                }}
              >
                <h2 style={{ fontSize: "18px", color: "#840040", margin: 0 }}>
                  Notification d’Information & Mise à Jour
                </h2>
              </div>

              <br />

              <p style={{ fontSize: "14px", color: "#555" }}>
                Chers utilisateurs,
              </p>

              <br />

              <ul
                style={{
                  fontSize: "14px",
                  color: "#555",
                  gap: "5px",
                  marginLeft: "3%",
                }}
              >
                <li style={{ marginBottom: "10px" }}>
                  • Nous sommes actuellement dans une phase de{" "}
                  <strong>
                    refonte complète de l’affichage de la plateforme
                  </strong>
                  .
                </li>

                <li style={{ marginBottom: "10px" }}>
                  • De ce fait, vous constaterez progressivement plusieurs
                  modifications visuelles et améliorations au fur et à mesure
                  des mises à jour.
                </li>

                <li style={{ marginBottom: "10px" }}>
                  • La méthode de travail ainsi que les fonctionnalités
                  principales restent inchangées afin de garantir la continuité
                  de vos activités.
                </li>

                <li style={{ marginBottom: "10px" }}>
                  • La section <strong>"Dashboard"</strong> est encore en cours
                  de développement. Nous vous informerons dès que les données et
                  informations définitives seront disponibles dans cette
                  section.
                </li>

                <li style={{ marginBottom: "10px" }}>
                  • Si vous constatez des erreurs, anomalies ou des difficultés
                  à effectuer certaines tâches suite au nouvel affichage, merci
                  de nous en informer via les tickets de support ou en
                  contactant directement l’équipe concernée si nécessaire.
                </li>
              </ul>

              <br />

              <p style={{ fontSize: "14px", color: "#555" }}>
                Merci pour votre compréhension et votre collaboration durant
                cette phase d’amélioration de la plateforme.
              </p>

              <br />

              <div style={{ textAlign: "center", marginTop: "25px" }}>
                <button
                  onClick={closeUpdateNotification}
                  style={{
                    padding: "10px 45px",
                    fontSize: "14px",
                    color: "#fff",
                    backgroundColor: "#840040",
                    border: "none",
                    borderRadius: "6px",
                    cursor: "pointer",
                    boxShadow: "1px 1px 6px rgba(0,0,0,0.15)",
                    transition: "0.3s",
                  }}
                  onMouseOver={(e) =>
                    (e.target.style.backgroundColor = "#6c0034")
                  }
                  onMouseOut={(e) =>
                    (e.target.style.backgroundColor = "#840040")
                  }
                >
                  Fermer
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Home;
